import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M12.973 1.172a.75.75 0 0 1-.2.701l-1.591 1.591.354.354 1.59-1.591a.75.75 0 0 1 1.242.29c.452 1.343.25 3.17-.973 4.392-1.118 1.117-2.563 1.22-3.763.934l-5.344 5.344a.75.75 0 0 1-1.061 0l-1.414-1.414a.75.75 0 0 1 0-1.06l5.345-5.345c-.288-1.2-.184-2.645.933-3.763C9.314.383 11.141.18 12.482.632a.75.75 0 0 1 .49.54Zm-2.404.784a2.636 2.636 0 0 0-1.417.71c-.71.71-.768 1.711-.441 2.68a.75.75 0 0 1-.18.77l-5.127 5.127.353.353L8.884 6.47a.75.75 0 0 1 .77-.18c.969.326 1.97.268 2.68-.442.387-.387.619-.894.71-1.417l-.978.978a.75.75 0 0 1-1.06 0L9.59 3.995a.75.75 0 0 1 0-1.06l.978-.98Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  c
];
function n(r, d) {
  return e(), l("svg", t, [...a]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
